import { pricelistApiClient } from "./clients";
import { PricelistResponse } from "types/pricelistApi.types";

export const getContractPricelist = (contractId: string) =>
  pricelistApiClient.request<PricelistResponse>({
    method: "GET",
    url: `/v1/contract/${contractId}/price-list`,
  });
